export default {"src":"/_next/static/media/instagram-white.596c3fb5.svg","height":24,"width":23,"blurWidth":0,"blurHeight":0};